// Application configuration
const config = {
  // Set to true for production environment
  isProduction: import.meta.env.PROD || window.location.hostname === 'www.usservicedogs.info',

  // PayPal payment link
  paypalPaymentLink: 'https://www.paypal.com/ncp/payment/SULHVZRRNMF6L',

  // Site verification URL (used in registry cards)
  verificationBaseUrl: window.location.hostname === 'www.usservicedogs.info'
    ? 'https://www.usservicedogs.info'
    : window.location.origin,
};

export default config;
